<div class="container-return-add-prod cpp-add-prod" (window:resize)="onresize($event)">
  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      Add Product(s) to the Return
    </h3>

    <div class="form-sec">
      <div class="row margin-r0">
        <div class="col-md-12 col-lg-12 smallPadRgt0">
          <!--<app-filter [optionsData]="filterOptionsData" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>-->
          <app-cpp-return-filter [filters]="filterOptionsData" (SearchFilter)="filterSearchClick($event)" (ClearFilter)="filterClearAllClick($event)"></app-cpp-return-filter>
        </div>
      </div>
    </div>
  </div>
  <div class="row canadaReturnsTabs">
    <div class="col-md-12 tabBgColor padding-t20">
      <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-head">
              <h4>
                Your Account Invoiced Products
              </h4>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer accInvProdTable">
            <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">

              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info">
                  <p class="vendorName"> {{element.itemVendorName}}</p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                  <!--<p class="itemNumber"> {{element.itemNumber}}</p>-->
                </td>
              </ng-container>

              <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef class="viewProduct text-center">&nbsp;</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);">
                    <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="LotNumber">
                <th mat-header-cell *matHeaderCellDef class="text-center lotNoBlock"> Lot/Serial Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.lotNumber}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="PackageSize">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Package Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSize}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="ProductLine">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine"> Product Line </th>
                <td mat-cell *matCellDef="let element" class="product-line text-center">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span>{{element.productLine}}</span>
                </td>
              </ng-container>

              Expanded Content Column - The detail row is made up of this one column that spans across all columns
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
                  <div>
                    <div class="cpp-prod-info mobile-nested-table">
                      <div class="row">
                        <div class="col-md-3">
                        </div>
                        <div class="col-md-6">
                          <table style="width:100%" class="m-0">
                            <thead>
                              <tr>
                                <th width="30%" class="text-left">Item # </th>
                                <th width="40%"> GTIN </th>
                                <th width="30%" class="text-right"> Active Ingredients </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="">
                                <th width="30%" class="d-block d-sm-block d-md-none">Item # </th>

                                <td width="30%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                                <th width="40%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                <td width="40%"><p>{{element.gtin}}</p></td>
                                <th width="30%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                <td width="30%" class="text-right"><p>{{element.activeIngredients}}</p> </td>
                              </tr>
                              <tr *ngIf="element.warningMessage">
                                <td mat-cell class="product-details" colspan="8">
                                  <div class="inline-error red-inline-error m-0">
                                    <div class="row">
                                      <div class="error-msg">{{element.warningMessage}}</div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-3">
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,false)"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-head">
              <h4>Parent Company Invoiced Products</h4>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer compInvProdTable">
            <table mat-table [dataSource]="parentAccountDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info">
                  <p class="vendorName"> {{element.itemVendorName}}</p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                  <!--<p class="itemNumber"> {{element.itemNumber}}</p>-->
                </td>
              </ng-container>
              <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef class="viewProduct text-center">&nbsp;</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);">
                    <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="LotNumber">
                <th mat-header-cell *matHeaderCellDef class="text-center lotNoBlock"> Lot/Serial Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.lotNumber}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="PackageSize">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Package Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSize}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="ProductLine">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine"> Product Line </th>
                <td mat-cell *matCellDef="let element" class="product-line text-center">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span>{{element.productLine}}</span>
                </td>
              </ng-container>

              Expanded Content Column - The detail row is made up of this one column that spans across all columns
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
                  <div>
                    <div class="cpp-prod-info mobile-nested-table">
                      <div class="row">
                        <div class="col-md-3">
                        </div>
                        <div class="col-md-6">
                          <table style="width:100%" class="m-0">
                            <thead>
                              <tr>
                                <th width="30%" class="text-left">Item # </th>
                                <th width="40%"> GTIN </th>
                                <th width="35%"> Active Ingredients </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="">
                                <th width="30%" class="d-block d-sm-block d-md-none">Item # </th>
                                <td width="30%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                                <th width="40%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                <td width="40%"><p>{{element.gtin}}</p></td>
                                <th width="30%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                <td width="30%"><p>{{element.activeIngredients}}</p> </td>
                              </tr>
                              <tr *ngIf="element.warningMessage">
                                <td mat-cell class="product-details" colspan="8">
                                  <div class="inline-error red-inline-error m-0">
                                    <div class="row">
                                      <div class="error-msg">{{element.warningMessage}}</div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-3">
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,true)"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-md-2 padding-l0">
      <button mat-raised-button class="btns wide100" color="primary" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add To Request</button>
    </div>
    <div class="col-md-2 padding-l0" *ngIf="isShowExportButton()">
      <button mat-raised-button class="btns wide100" color="primary" [disabled]="isDisableExportButton()" (click)="export()">Export</button>
    </div>
    <div class="col-md-8 text-right" *ngIf="isShowExportButton()">
      <span class="count">Product selected <span>{{selectedProductList.length}} </span></span>
    </div>
    <div class="col-md-10 text-right" *ngIf="!isShowExportButton()">
      <span class="count">Product selected <span>{{selectedProductList.length}} </span></span>
    </div>
  </div>
</div>
